import React, { useState } from 'react';
import { flowRight as compose } from 'lodash';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';

// Component
import ListingManagement from '../../../components/siteadmin/ListingManagement';

import s from './Listings.css';

const Listings = () => {

  const [state, setState] = useState({ currentPage: 1, searchList: '', listStatus: 2 });

  const setStateVariable = (variables) => {
    setState(prev => ({
      ...prev,
      ...variables
    }));
  };

  const { currentPage, searchList, listStatus } = state;

  return <ListingManagement
    currentPage={currentPage}
    searchList={searchList}
    listStatus={listStatus}
    setStateVariable={setStateVariable} />;
}

export default compose(withStyles(s))(Listings);

